import { createFileRoute } from "@tanstack/react-router";
import { faqPageJsonLd } from "@/components/site/faq-page-data";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/faq")({
  head: () => {
    const { meta, links } = seo({
      title: "FAQ",
      description:
        "Straight answers on spray foam, blown, and batting in Northwest Wisconsin. SeaClay in Prairie Farm, WI. No sales pitch.",
      path: "/faq",
    });

    return {
      meta,
      links,
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(faqPageJsonLd()),
        },
      ],
    };
  },
});
